import { useState } from "react";
import { Pagination, Select } from "antd";
import _ from "lodash";
import formatPnlText from "../Helpers/formatPnl";
import getPnlInfo from "../Helpers/getPnlInfo";
import imagesUrls from "../Constants/imagesUrls";
import "./index.css";

export default function DashboardTable({ selectedSegment, data }) {
  const [page, setPage] = useState(1);
  const [postsPerPage, setPostsPerPage] = useState(10);
  const structuredSegments = _.keyBy(data.pnl_data.pl_data, "name");
  const selectedSegmentData = structuredSegments[selectedSegment]
    ? structuredSegments[selectedSegment]
    : [];
  const total = Math.ceil(selectedSegmentData.data.length);
  const indexOfFirstPage = (page - 1) * postsPerPage;
  const indexOfLastPage = page * postsPerPage;
  const currentPosts = selectedSegmentData.data.slice(
    indexOfFirstPage,
    indexOfLastPage
  );

  function handleSizeChange(pageNumber) {
    setPostsPerPage(pageNumber);
    setPage(1);
  }

  return (
    <>
      <div className="table-container p-3">
        <div className="main-heading my-3">
          <img src={imagesUrls.document_icon} className="mr-2" alt="title" />
          <span>{getPnlInfo(data)}</span>
        </div>
        <div className={`table-wrapper-container mb-5 mb-md-0 ${data.custom_options.hidePosition ? "overflow-hidden min-height-400" : ""}`}>
          <table className="table">
            <thead className="">
              <tr>
                <th className="table-th-name">Name</th>
                <th>Buy qty</th>
                <th>Sell qty</th>
                <th>Net qty</th>
                <th>Realized P&L</th>
                <th>Unrealized P&L</th>
                <th>Total P&L</th>
              </tr>
            </thead>
            <tbody>
              {currentPosts &&
                currentPosts.map((data, index) => (
                  <tr
                    className={`overview-table-data ${data.net_qty ? "overview-active-holding" : ""
                      }`}
                    key={index}
                  >
                    <td className="text-left">{data.symbol}</td>
                    <td className="text-right">{data.buy_qty}</td>
                    <td className="text-right">{data.sell_qty}</td>
                    <td
                      className={`text-right ${data.net_qty ? "overview-active-net-qty" : ""
                        }`}
                    >
                      {data.net_qty}
                    </td>
                    <td className="text-right">
                      {formatPnlText.withoutColor(data.pl_realized)}
                    </td>
                    <td className="text-right">
                      {formatPnlText.withoutColor(data.pl_unrealized)}
                    </td>
                    <td className="text-right">
                      {data.net_qty
                        ? formatPnlText.withColor(data.pl_total)
                        : formatPnlText.withoutColor(data.pl_total)}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
          {
            data.custom_options.hidePosition ?
              <div className="private-content">
                <div>Private Content</div>
              </div> : <></>
          }
        </div>
        {
          data.custom_options.hidePosition ?
            <div className="private-content">
              <div class>
                <img src="https://assets.fyers.in/verified-pnl/images/eye.svg" />
                <div className="header">Private Content</div>
                <p>The user has shared the  verified P&L data anonymously</p>
              </div>
            </div> : <></>
        }
        <Pagination
              onChange={(value) => setPage(value)}
              pageSize={postsPerPage}
              total={total}
              current={page}
              showSizeChanger={false}
              showQuickJumper={false}
            />
      </div>
    </>
  );
}